import { computed, defineComponent, ref, watch, type CSSProperties, type PropType } from 'vue'
import { useSiteConfigStore } from '@/stores/site-config-store'

export default defineComponent({
  name: 'UserAvatar',
  inheritAttrs: false,
  props: {
    src: { type: String as PropType<string | null | undefined>, default: '' },
    size: { type: [Number, String] as PropType<number | string>, default: '' },
    round: { type: Boolean, default: true },
    alt: { type: String, default: '' },
  },
  setup(props, { attrs }) {
    const failed = ref(false)
    const siteConfigStore = useSiteConfigStore()
    watch(
      () => props.src,
      () => {
        failed.value = false
      },
    )

    const showImg = computed(() => Boolean(props.src) && !failed.value)

    const sizeStyle = computed<CSSProperties>(() => {
      if (props.size === '' || props.size === 0) return {}
      const s = typeof props.size === 'number' ? `${props.size}px` : props.size
      return { width: s, height: s }
    })

    /** 有头像用头像（加载失败置 failed），否则用站点 Logo，都没有就只留底色 */
    function renderImage() {
      if (showImg.value) {
        return (
          <img
            src={props.src as string}
            alt={props.alt}
            referrerpolicy="no-referrer"
            class="relative block w-full h-full object-cover"
            onError={() => {
              failed.value = true
            }}
          />
        )
      }
      if (siteConfigStore.siteLogo) {
        return <img src={siteConfigStore.siteLogo} alt={props.alt} class="block w-full h-full object-cover" />
      }
      return null
    }

    return () => {
      const userClass = attrs.class || ''
      const userStyle = (attrs.style as CSSProperties) || {}
      const rootClass = [
        'relative inline-block overflow-hidden align-top bg-[#dcdee0]',
        props.round ? 'rounded-full' : 'rounded',
        !props.size && 'w-full h-full',
        userClass,
      ]

      return (
        <div
          {...attrs}
          class={rootClass}
          style={{
            ...sizeStyle.value,
            ...userStyle,
          }}
        >
          <div class="absolute inset-0 flex items-center justify-center text-white pointer-events-none"></div>
          {renderImage()}
        </div>
      )
    }
  },
})
